import React from 'react';
import _ from 'lodash';
import Preview from './preview_component';
import Header from './walk_through/header';
import Buttons from './walk_through/buttons';
import PageToggler from './page_toggler_component';
import ErrorPage from 'better_error_pages/app';

// Questions
import Welcome from './walk_through/questions/welcome'; // Step 0
import HaveStatusPage from './walk_through/questions/have_status_page'; // Step 1
import UrlsForm from './walk_through/questions/urls_form'; // Step 2
import ChooseTemplate from './walk_through/questions/choose_template'; // Step 3
import Personalize from './walk_through/questions/personalize'; // Step 4
import Download from './walk_through/questions/download'; // Step 5
import ThankYou from './walk_through/questions/thank_you'; // Step 6

class GetStarted extends React.Component {
  constructor(props) {
    super(props);

    let state = props.bep;
    state.loggedIn = window.loggedIn;
    state.page_type = '503';
    state.step = 0;
    state.downloadRequestSent = false;
    state.reddit_link = props.reddit_link || '';
    state.hacker_news_link = props.hacker_news_link || '';
    state.product_hunt_link = props.product_hunt_link || '';
    state.thumbnails = props.thumbnails;
    state.defaults = props.defaults;

    this.state = state;
    this.cache = {};

    this.pushStateToServer = _.debounce(() => {
      // If there's nothing to update, don't push an update!
      if (Object.keys(this.cache).length === 0) return;
      $.ajax({
        url: '/customize/' + this.props.bep.id,
        type: 'PUT',
        data: { bep: this.cache },
      }).always(
        function () {
          this.cache = {};
        }.bind(this),
      );
    }, 200);

    this.getCodeFromUrl = _.debounce((value) => {
      $.ajax({
        type: 'GET',
        url: '/page_code?q=' + value,
      })
        .done(
          function (response) {
            this.update('page_code', response.page.id);
          }.bind(this),
        )
        .fail(
          function () {
            ErrorPage.prototype.handleStatusFetchFail();
            this.triggerAlert(
              'The Statuspage URL or code you entered was invalid.  Please try again.',
              'error',
            );
            this.setState({ page_code: null });
          }.bind(this),
        );
    }, 1000);
  }

  componentDidMount() {
    this.preloadImages();
  }

  preloadImages() {
    // preloads template images to prevent need to resize after the step is shown
    let img1 = new Image(),
      img2 = new Image(),
      img3 = new Image();

    img1.src = this.props.thumbnails.plain;
    img2.src = this.props.thumbnails.background;
    img3.src = this.props.thumbnails.sign;
  }

  resetDefaultValues = (template) => {
    var defaults = this.props.defaults[template];

    for (var prop in defaults) {
      if (prop === 'template') {
        return;
      }
      this.update(prop, defaults[prop]);
    }
  };

  update = (key, value) => {
    let newState = {};
    newState[key] = value;

    if (key === 'has_status_page') {
      newState.page_code = null;
    }

    // We need to cache our updates so the debounced server update posts everything
    this.cache[key] = value;

    this.setState(newState, (state) => {
      if (key === 'template') this.resetDefaultValues(value);

      if (
        key === 'status_page_url' &&
        this.state.has_status_page === 'customer' &&
        !!this.state.status_page_url
      ) {
        this.getCodeFromUrl(value);
      }

      this.pushStateToServer();
    });
  };

  renderQuestion() {
    switch (this.state.step) {
      case 0:
        return <Welcome />;
      case 1:
        return <HaveStatusPage {...this.state} onChange={this.update} />;
      case 2:
        return <UrlsForm {...this.state} onChange={this.update} />;
      case 3:
        return <ChooseTemplate {...this.state} onChange={this.update} />;
      case 4:
        return (
          <Personalize
            {...this.state}
            onChange={this.update}
            resetDefaultValues={this.resetDefaultValues}
          />
        );
      case 5:
        return <Download {...this.state} onChange={this.update} />;
      case 6:
        return <ThankYou {...this.state} onChange={this.update} />;
      default:
        return <Welcome {...this.state} onChange={this.update} />;
    }
  }

  triggerAlert(text, type) {
    HRB.utils.notify(text, { cssClass: type });
  }

  canContinue() {
    if (
      this.state.step === 5 &&
      this.state.send_to_email_address &&
      this.state.send_to_email_address.indexOf('@') > 1
    ) {
      return true;
    } else if (
      this.state.step === 2 &&
      this.state.has_status_page === 'customer' &&
      !this.state.page_code
    ) {
      return false;
    }
    return this.state.step <= 4 && this.state !== 6;
  }

  canGoBack() {
    return this.state.step !== 0;
  }

  continue = () => {
    if (this.canContinue()) {
      if (
        this.state.step === 1 &&
        this.state.has_status_page === 'customer' &&
        !!this.state.status_page_url &&
        !this.state.page_code
      ) {
        // If customer is selected, and a status page url is defined and page code is not, pull the page code
        this.getCodeFromUrl(this.state.status_page_url);
      }

      if (this.state.step === 5 && this.state.downloadRequestSent === false) {
        this.submitDownloadRequest();
      }
      this.setState({ step: this.state.step + 1 });
    }
  };

  back = () => {
    if (this.canGoBack()) {
      this.setState({ step: this.state.step - 1 });
    }
  };

  continueText() {
    if (this.state.step === 6) return null;
    return this.state.step === 5 ? 'Get error pages' : 'Continue';
  }

  backText() {
    return this.state.step <= 1 ? null : 'Back';
  }

  submitDownloadRequest() {
    $.ajax({
      type: 'POST',
      url: '/request_download',
      data: {
        download_request: {
          send_to_email_address: this.state.send_to_email_address,
          bep_id: this.props.bep.id,
          subscribe_to_news_letter: this.state.subscribe_to_news_letter,
        },
      },
      success: function (response) {},
    });
    this.state.downloadRequestSent = true;
  }

  setPageType = (type) => this.update('page_type', type);

  preview() {
    if (this.state.step > 2 && this.state.step !== 6) {
      return (
        <div className="preview-container">
          <PageToggler {...this.state} onChange={this.setPageType} />
          <Preview {...this.state} />
        </div>
      );
    }

    return (
      <div className="preview-container" style={{ display: 'table' }}>
        <div className="default-preview">
          <img src={this.props.logo_url} style={{ width: '25%' }} />
        </div>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        <div className="walkthrough-container">
          <Header
            logoUrl={this.props.header_logo_url}
            poweredByUrl={this.props.powered_by_url}
          />
          {this.renderQuestion()}
          <Buttons
            continue={this.continue}
            continueText={this.continueText()}
            back={this.back}
            backText={this.backText()}
          />
        </div>
        {this.preview()}
      </React.Fragment>
    );
  }
}

export default GetStarted;
